import { render, staticRenderFns } from "./GuidancePlanFormItem.vue?vue&type=template&id=8d9b0a04&"
import script from "./GuidancePlanFormItem.vue?vue&type=script&lang=ts&"
export * from "./GuidancePlanFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports